import React from "react";
import { withRouter } from "react-router-dom";
import MainLayout from "layouts/main";
import AuthLayout from "layouts/auth";
import ClientsLayout from "layouts/clients";
import SupportLayout from "layouts/support";
import LastMileLayout from "layouts/lastmile";
import ClientLeadLayout from "layouts/clientLead";
import CordinatorLayout from "layouts/cordinator";
import OwnerLayout from "layouts/owner";
import LeadsLayout from "layouts/leads";
import Authentication from "views/private/routes/authentication";
import CRM from "views/private/routes/crm";
import Leads from "views/private/routes/leads";
import Owner from "views/private/routes/owner";
import Cordinator from "views/private/routes/cordinator";
import ClientLead from "views/private/routes/clientLead";
import Clients from "views/private/routes/clients";
import Support from "views/private/routes/support";
import Lastmile from "views/private/routes/lastmile";
import { useUser } from "providers/user";
import { BeatingContainer } from "./elements";

const Private = () => {
  const { user, loadingUser } = useUser();

  if (!user) {
    return (
      <AuthLayout>
        <Authentication />
      </AuthLayout>
    );
  }

  if (loadingUser)
    return (
      <BeatingContainer>
        <img src="/icon.png" alt="En construcción..." />
      </BeatingContainer>
    );

  if (user.type === "lead") {
    return (
      <LeadsLayout>
        <Leads />
      </LeadsLayout>
    );
  }
  if (user.type === "client") {
    return (
      <ClientsLayout>
        <Clients />
      </ClientsLayout>
    );
  }
  if (user.type === "support") {
    return (
      <SupportLayout>
        <Support />
      </SupportLayout>
    );
  }
  if (user.type === "clientLead") {
    return (
      <ClientLeadLayout>
        <ClientLead />
      </ClientLeadLayout>
    );
  }
  if (user.type === "owner") {
    return (
      <OwnerLayout>
        <Owner />
      </OwnerLayout>
    );
  }
  if (user.type === "cordinator") {
    return (
      <CordinatorLayout>
        <Cordinator />
      </CordinatorLayout>
    );
  }
  if (user.type === "lastMile") {
    return (
      <LastMileLayout>
        <Lastmile />
      </LastMileLayout>
    );
  }
  if (user.type === "admin") {
    return (
      <MainLayout>
        <CRM />
      </MainLayout>
    );
  }
  return (
    <BeatingContainer>
      <img src="/icon.png" alt="En construcción..." />
    </BeatingContainer>
  );
};

export default withRouter(Private);
